import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';
import { DutyEngineerCategory } from 'icreate/common/models/duty-engineer-category';

@Injectable({
    providedIn: 'root',
})
export class DutyEngineerCategoryService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async bulkCreateOrUpdate(records: DutyEngineerCategory[]) {
        return await lastValueFrom(
            this.http.post<DutyEngineerCategory[]>(`${this.domain}/api/duty-engineer-category`, records, {
                headers: this.headers,
            })
        );
    }

    async getList(dutyEngineerId: string) {
        return await lastValueFrom(
            this.http.get<DutyEngineerCategory[]>(`${this.domain}/api/duty-engineer-category/${dutyEngineerId}`, {
                headers: this.headers,
            })
        );
    }

    async getListByVesselId(vesselId: string) {
        return await lastValueFrom(
            this.http.get<DutyEngineerCategory[]>(`${this.domain}/api/duty-engineer-category/vessel/${vesselId}`, {
                headers: this.headers,
            })
        );
    }
}
